import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Small } from 'foundations-components/transitional/components/Small';
import { useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import withErrorBoundary from '../../../v2/components/error-boundary/withErrorBoundary';
import { useAllRequiredOnboardingApiNamesFromList, useRequiredOnboardingApiNamesByProductLevel, useRequiredOnboardingChoiceApiNames } from '../../hooks/onboarding/useRequiredOnboarding';
import RequiredOnboardingSubtext from './RequiredOnboardingSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RequiredOnboardingSubtextContainer = ({
  productApiNames,
  tab,
  trackingSource,
  includesOnboardingCost = false
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const productsToPurchase = productApiNames.map(apiName => ({
    productApiName: apiName,
    quantity: 1
  }));
  const {
    onboardingApiNamesMap
  } = useRequiredOnboardingApiNamesByProductLevel({
    productsToPurchase
  });
  const {
    allRequiredOnboardingApiNames
  } = useAllRequiredOnboardingApiNamesFromList({
    productsToPurchase
  });
  const {
    requiredOnboardingChoiceApiNames
  } = useRequiredOnboardingChoiceApiNames({
    productsToPurchase
  });
  const hasOnboardingChoices = requiredOnboardingChoiceApiNames.length > 0;
  if (hasOnboardingChoices && !includesOnboardingCost) {
    return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.requiredOnboardingSubtext.genericNotIncluded"
        })
      })
    });
  }

  // If there are multiple onboarding products, don't show a price
  if (allRequiredOnboardingApiNames.length > 1) {
    return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.requiredOnboardingSubtext.genericIncluded"
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.keys(onboardingApiNamesMap).map(langKey => /*#__PURE__*/_jsx(RequiredOnboardingSubtext, {
      productApiNames: onboardingApiNamesMap[langKey],
      currencyCode: currencyCode,
      langKey: langKey,
      tab: tab,
      trackingSource: trackingSource,
      includesOnboardingCost: includesOnboardingCost
    }, langKey))
  });
};
export default withErrorBoundary(RequiredOnboardingSubtextContainer, {
  fallback: null
});